import Grid from "@material-ui/core/Grid";
import { Card } from "@material-ui/core";
import * as Diff from "diff";
import { useATCPlan } from "../../store/ATCPlanState";

const formatPlan = str => {

  let atcStr = str.replace(/\r\n/g, "\n").split("\n").map((line) => {
    const trimmedLine = line.trim();
    if(trimmedLine.indexOf("-") === -1) {
      return ` ${trimmedLine}`;
    } else {
      return trimmedLine;
    }
  }).join("");
  atcStr = atcStr.split("-").map((line, index) => {
    if(index === 0) {
      return line;
    }
    else if(0 <= [3, 5, 6, 7, 8].indexOf(index)) {
      return `\n-${line}`;
    } else {
      return `-${line}`;
    }
  }).join("");

  return atcStr;
}

const CompareView = () => {
  const {atcPlan} = useATCPlan();
  const original = formatPlan(atcPlan.original.text);
  const edit = formatPlan(atcPlan.edit.text);
  const difference = [];
  const diff = Diff.diffWords(original, edit);
  for (let i=0; i < diff.length; i++) {

    if (diff[i].added && diff[i + 1] && diff[i + 1].removed) {
      const swap = diff[i];
      diff[i] = diff[i + 1];
      diff[i + 1] = swap;
    }

    if (diff[i].removed) {
      difference.push(<del>{diff[i].value}</del>);
    } else if (diff[i].added) {
      difference.push(<ins>{diff[i].value}</ins>);
    } else {
      difference.push(diff[i].value);
    }
  }

  return (
    <div style={{height: 400}}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="atc-diff-box">
            <div>Before</div>
            <Card id="before-atc">
                <pre>
                  {original}
                </pre>
            </Card>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="atc-diff-box">
            <div>After</div>
            <Card id="after-atc">
                <pre>
                  {edit}
                </pre>
            </Card>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="atc-diff-box">
            <div>Difference</div>
            <Card>
                <pre id="diff-atc">
                  {difference}
                </pre>
            </Card>
          </div>
        </Grid>
      </Grid>
    </div>
  )
};

export default CompareView;